<template>
  <div>
    <modal id="delete-address" v-if="selectedAddress">
      <div slot="header" class="card-header">
        {{ translations.warning }}!
      </div>
      <div slot="body" class="card-body">
        <h4 class="font-weight-bold text-dark"><i class="fas fa-question-circle">
        </i> {{ translations.attention }}!</h4>
        <div class="modal-text">
          <p>{{ translations.areYouSureYouWantToDeleteAddress }}</p>
        </div>
      </div>
      <div slot="footer" class="card-footer">
        <div class="d-flex justify-content-end">
          <button
            class="btn btn-default modal-dismiss me-2"
            @click="closeDeleteAddressModal"
          >
            {{ translations.cancel3 }}
          </button>
          <button
            class="btn btn-primary modal-confirm ml-3"
            @click="deleteAddress"
          >
            {{ translations.delete }}
          </button>
        </div>
      </div>
    </modal>
    <h3 class="account-sub-title d-none d-md-block mb-1">
      <i class="sicon-location-pin align-middle mr-3"></i>
      {{ translations.addresses }}
    </h3>
    <div class="addresses-content">
      <p class="mb-4">
        {{ translations.defaultAddress }}
      </p>
      <div class="row">
        <div class="address" v-if="addresses && addresses.length === 0">
          <div class="address-box">
            <p class="pl-4">
              {{ translations.notSetAnyAddressYet }}
            </p>
          </div>
        </div>
        <div class="shipping-addresses">
          <div
            class="shipping-address-box"
            :class="{ active: address.isDefault }"
            v-for="address in addresses"
            :key="address.id"
          >
            <address>
              {{ address.address }} <br />
              {{ address.town }}, {{ address.country }}, {{ address.zipCode }} <br />
              {{ address.country }} <br />
              {{ address.phoneNumber }} <br />
            </address>
            <div class="address-box-action clearfix d-flex">
              <router-link
                :to="{ name: 'EditAddress', params: { id: address.id } }"
                class="btn btn-sm btn-link"
              >
                {{ translations.edit }}
              </router-link>
              <button class="btn btn-sm btn-link ml-auto" @click="showDeleteAddressModal(address)">
                <i class="fa fa-trash"></i>
                {{ translations.delete }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <router-link
            :to="{ name: 'NewAddress' }"
            class="btn btn-sm btn-outline-secondary btn-new-address"
          >
            {{ translations.newAddress }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { translations } from '@/mixins';
import api from '@/services/api';

import Modal from '@/components/shared/modal/Modal.vue';

export default {
  name: 'Addresses',
  mixins: [translations],
  components: { Modal },
  data() {
    return {
      selectedAddress: null,
    };
  },
  computed: {
    addresses() {
      return this.$store.getters.getShippingAddresses;
    },
  },
  methods: {
    showDeleteAddressModal(address) {
      this.selectedAddress = address;

      this.$nextTick(() => {
        $('#delete-address').modal('show');
      });
    },
    closeDeleteAddressModal() {
      $('#delete-address').modal('hide');
    },
    deleteAddress() {
      api.deleteShippingAddress(this.selectedAddress.id).then((response) => {
        this.$toast.info(response.data.info);
        this.$store.dispatch('getShippingAddresses');
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      }).finally(() => {
        this.closeDeleteAddressModal();
      });
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.dispatch('getShippingAddresses');
  },
};
</script>

<style scoped>
.shipping-address-box.active .address-box-action {
  visibility: visible;
}
</style>
